module.exports = __webpack_public_path__ + "static/media/404.07dd6b2b.svg";